module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-divider', [_vm._v("如有信息需要修改，请加微信联系CCA工作人员")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("长按保存到相册")]), _vm._v(" "), _vm._l((_vm.imgs), function(src) {
    return (_vm.imgs.length > 0) ? _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin": "10px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": src
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.imgs.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px"
    }
  }, [_vm._v("工作人员二维码未配置")]) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164433c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiConfirmQr2.vue
// module id = 2210
// module chunks = 0